<template>
  <div class="searchDiv" v-if="isShow">
    <!-- <Input icon="ios-search" placeholder="请输入搜索内容" style="width: 100%" v-model.trim="keyword" @on-keydown="onkeydown" /> -->
    <div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type">
      <span class="ivu-input-suffix">
        <i class="ivu-icon ivu-icon-ios-search"></i>
      </span>
      <i class="ivu-icon ivu-icon-ios-loading ivu-load-loop ivu-input-icon ivu-input-icon-validate"></i>
      <!-- style="border-radius: 32px;background:#F5F5F5;" -->
      <input autocomplete="off" spellcheck="false" type="text" v-model="keyword" @keyup.enter="onkeydown" placeholder="请输入搜索关键词" class="ivu-input ivu-input-default ivu-input-with-suffix circular"
        style="height:33px;border-radius:33px;">
    </div>
    <div class="demo-spin-article fx__box" v-if="groups.length>0" v-clickoutside="handleClose">
      <div style="text-align: center;font-size:12px;">找到匹配数{{total}}</div>
      <div style="flex:1; overflow: auto;">
        <searchItem v-for="(item, index) in groups" :key="index" :Opts="item">
        </searchItem>
      </div>
    </div>

  </div>
</template>
<script>
import searchItem from "./searchItem";
const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false;
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e, el);
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener("click", documentHandler);
  },
  update() {},
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener("click", el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
};
export default {
  directives: { clickoutside },
  name: "searchInput",
  components: {
    searchItem
  },
  provide() {
    return {
      closeSearchDiv: () => {
        this.groups = [];
      }
    };
  },
  computed: {
    total() {
      let sum = 0;
      this.groups.forEach(p => {
        sum += p.count;
      });
      return sum;
    },
    isShow() {
      let search = this.$app.Setting.core.search;
      return search && search.length > 0;
    }
  },
  data() {
    return {
      keyword: "",
      groups: [],
      spinShow: true,
      search: this.$app.Setting.core.search
    };
  },
  mounted() {
    console.log("搜索功能", this.$app.Setting.core);
  },
  methods: {
    handleClose(e, el) {
      el.style.visibility = "hidden";
    },
    startSearch() {
      this.groups = [];
      let coresetting = this.$app.Setting.core;
      if (!coresetting) {
        alert("没有配置全局搜索config/core/search.config.js");
        return;
      }
      let searchOpts = coresetting.search.map(p => {
        return {
          url: p.url,
          text: p.text,
          count: 0,
          keyword: this.keyword
        };
      });
      this.keyword = "";

      this.$nextTick(() => {
        setTimeout(() => {
          this.groups = searchOpts;
        }, 500);
      });
    },
    onkeydown(event) {
      if (event.key == "Enter") {
        this.startSearch();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
input::-webkit-input-placeholder {
  text-indent: 10px;
}
.demo-spin-article {
  position: absolute;
  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
  // background-color: white;
}
.searchDiv {
  position: relative;
  z-index: 100;
}
</style>